import React from "react";
import PropTypes from "prop-types";
import { renderIf } from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";
import { REPAIR_EVALUATION_REJECTED } from "MODULES/inventories/constants";
import {
  CLOSED,
  OPENED,
  REPAIR_EVALUATION_RECEIVED,
  REQUESTED
} from "../../../../../constants";

function RequestVendorRma({ toggleRequestModal }) {
  return (
    <DropDownItem onClick={toggleRequestModal}>
      <Icon name="envelope" fixed />
      Request Vendor RMA
    </DropDownItem>
  );
}

export const canRequestVendorRma = ({ lineItem }) =>
  [REPAIR_EVALUATION_REJECTED, REPAIR_EVALUATION_RECEIVED].includes(
    lineItem.approval_status
  ) &&
  !lineItem.final_evaluation_approved &&
  !lineItem.vendor_rma_requested &&
  !lineItem.exchange &&
  ![REQUESTED, OPENED, CLOSED].includes(lineItem.vendor_rma_status);

export default renderIf(canRequestVendorRma)(RequestVendorRma);

RequestVendorRma.propTypes = {
  toggleRequestModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RequestVendorRma/RequestVendorRma.jsx